import React from 'react';
import { IonAlert } from '@ionic/react';

interface AlertAceptarProps {
    isOpen: boolean;
    message: string;
    onDidDismiss: () => void;
    trigger?: string;
}

export function AlertAceptar({ isOpen, message, onDidDismiss, trigger }: AlertAceptarProps) {
    return (
        <IonAlert
            isOpen={isOpen}
            onDidDismiss={onDidDismiss}
            trigger={trigger}
            message={message}
            buttons={['Aceptar']}
        ></IonAlert>
    );
}